export default __webpack_public_path__ + "bb06a6e081c0fc2f8dd56be882b9262a.png";